export default __webpack_public_path__ + "static/media/mercedes.bbad7452.png";